import GuidEventLookupModelBase from '../_generated/modelBases/guid-event-lookup-model-base';

export default class GuidEventLookupModel extends GuidEventLookupModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
